module.exports = __webpack_public_path__ + "img/bg1.ca78c781.jpg";